import { MintContentWrapper, StyledTitle } from "components/Shared/styled";
import React from "react";
import { StatusWrapper } from "./styled";
import { ReactComponent as StatusSuccess } from "assets/images/minting/success.svg";
import { ReactComponent as StatusFailed } from "assets/images/minting/error.svg";

const MintStatus = ({ isSuccess }: { isSuccess: boolean }) => {
  return (
    <MintContentWrapper flexDirection="column" justifyContent="center">
      <StyledTitle>
        {isSuccess ? "Your Minting Success" : "Your Minting Failed"}
      </StyledTitle>
      <StatusWrapper justifyContent="center" alignItems="center">
        {isSuccess ? <StatusSuccess /> : <StatusFailed />}
      </StatusWrapper>
    </MintContentWrapper>
  );
};

export default MintStatus;
